import React, { useEffect, useState, useRef } from "react";
import PageTitle from "../../Module/pageTitle";
import LabelField from "../../Component/labelField";
import CustomDropdown from "../../Component/customDropdown";
import {
  getExamSectionList,
  getResultCompilationList,
} from "../../Action/campaignAction";
import { getExamTypeSectionList } from "../../Action/adminPanelAction";
import { useDispatch } from "react-redux";
import { getSubExam } from "../../Action/adminPanelAction";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import { pdf_size_50MB, validateIsFileExcelType } from "../../Utils/validators";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import { validateIsFileExcelTypeErrMsg } from "../../Utils/errorMsg";
import SubmitButton from "../../Component/SubmitButton";
import * as xlsx from "xlsx";
import { DownloadTableExcel } from "react-export-table-to-excel";
const ImportResultCompilation = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [examName, setExamName] = useState("");
  const [examList, setExamList] = useState([]);
  const [resetExam, setResetExam] = useState(false);
  const [examStream, setExamStream] = useState("");
  const [examStreamList, setExamStreamList] = useState([]);
  const [resetExamStream, setResetExamStream] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [StudentDetailsArr, setStudentDetailsArr] = useState([]);
  const [resultList, setResultList] = useState([]);

  useEffect(() => {
    dispatch(
      getExamTypeSectionList((res) => {
        if (res) {
          setExamList(res);
        }
      }),
    );

    dispatch(
      getExamSectionList((res) => {
        setExamStreamList(res?.data);
      }),
    );
  }, []);

  const onChangeExamStream = (val) => {
    setExamStream(val);
  };

  const onChangeExam = (value) => {
    setExamName(value);
    setResetExam(false);
  };
  const handleEXCELChange = (e) => {
    e.preventDefault();
    if (!validateIsFileExcelType(e)) {
      dispatch(showErrorSnackbar(validateIsFileExcelTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_50MB) {
      dispatch(showErrorSnackbar("File size should be less than 50 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      if (file) {
        reader.onload = (e) => {
          setSelectedFile(file?.name);
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = xlsx.utils.sheet_to_json(worksheet);
          let newArr = jsonData?.map((item) => {
            return {
              studentName: item?.studentName ? String(item?.studentName) : "",
              rank: item?.rank ? String(item?.rank) : "",
              arg1: item?.arg1 ? String(item?.arg1) : "",
              arg2: item?.arg2 ? String(item?.arg2) : "",
            };
          });
          setStudentDetailsArr(newArr);
        };
        reader.readAsBinaryString(file);
      }
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const reqBody = {
      exams: examName?.examTypeId,
      examStreams: examStream?.baseCourseId,
      studentsData: StudentDetailsArr,
    };

    dispatch(
      getResultCompilationList(
        reqBody,
        (res) => {
          if (res) {
            setResultList(res?.data);
          }
        },
        () => {},
      ),
    );
  };
  const validation = () => {
    return selectedFile === "";
  };
  const renderForm = () => {
    return (
      <form className="formWidth row d-flex" onSubmit={handleSubmit}>
        <div className="col-md-6 d-flex align-items-center">
          <LabelField labelName={"Exam Name"} />
          <CustomDropdown
            setInputText={(value) => onChangeExam(value)}
            value={examName}
            options={examList}
            labelName="Select Exam Name"
            reset={resetExam}
          />
        </div>

        <div className="col-md-6 d-flex align-items-center">
          <LabelField labelName={"Exam Stream"} />
          <CustomDropdown
            setInputText={(value) => onChangeExamStream(value)}
            value={examStream}
            options={examStreamList}
            labelName="Select Exam Stream"
            reset={resetExamStream}
          />
        </div>
        <div className="d-flex align-items-center">
          <LabelField labelName={"Upload Excel"} />
          <ImagePickerAndViewer
            labelName={"Upload Sample EXCEL"}
            // value={excelFile}
            handleChange={(e) => handleEXCELChange(e)}
            htmlFor={`photo-upload`}
            doctype={"excel"}
            removelabel={true}
            selectedPDF={selectedFile}
            isRequired={true}
          />
          <label className="label">
            {selectedFile ? selectedFile : "Sample Excel"}
          </label>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <SubmitButton name="Import" validations={validation()} />
          <div className="d-flex mb-2 align-items-center">
            <DownloadTableExcel
              filename="Result_compilation_details"
              sheet="Result Compilation Details"
              currentTableRef={tableRef.current}
            >
              <button className="btn btn-outline-primary mb-3 submitbtn py-1">
                Export Details
              </button>
            </DownloadTableExcel>
          </div>
        </div>
      </form>
    );
  };
  const renderTable = () => {
    return (
      <div className="col-12 formWidth" ref={tableRef}>
        <table className="w-100">
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Current Name</th>
              <th>Mobile Number</th>
              <th>Exam Name</th>
              <th>Exam Stream</th>
              <th>Course Name</th>
              <th>Rank</th>
              <th>Arg1</th>
              <th>Arg2</th>
              <th>Profile Image</th>
            </tr>
          </thead>
          {resultList?.length > 0 ? (
            <tbody>
              {resultList?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.firstName}</td>
                    <td>{item?.lastName}</td>
                    <td>{item?.currentName}</td>
                    <td>{item?.mobileNo}</td>
                    <td>{item?.examName}</td>
                    <td>{item?.baseCourse}</td>
                    <td>{item?.courseName}</td>
                    <td>{item?.rank}</td>
                    <td>{item?.arg1}</td>
                    <td>{item?.arg2}</td>
                    <td>
                      <img
                        src={item?.profilePicture}
                        alt={item?.firstName}
                        width="50"
                        height="50"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td>No record found.</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    );
  };

  return (
    <div className="contentBox">
      <PageTitle name={"IMPORT RESULT COMPILATION"} />
      <div className="formDiv">
        {renderForm()}
        {renderTable()}
      </div>
    </div>
  );
};

export default ImportResultCompilation;
